var _a;
import { ofType } from "redux-observable";
import { map } from "rxjs/operators";
import { IdOutskirtBuildings } from "../../../../constants/IdOutskirtBuildings";
import { actionOutskirtBuildingSelect } from "../../../info/outskirts/actionOutskirtsInfo";
import { actionModalSwapLast } from "../../../modals/actionModal";
import { IdModal } from "../../../modals/IdModal";
import { TypeActionShowMe } from "../../actionShowMe";
var menuIdsByOutskirtBuildingIds = (_a = {},
    _a[IdOutskirtBuildings.Doghouse] = IdModal.Doghouse,
    _a[IdOutskirtBuildings.Market] = IdModal.Market,
    _a[IdOutskirtBuildings.Cafe] = IdModal.Cafe,
    _a[IdOutskirtBuildings.Harbor] = IdModal.Harbor,
    _a[IdOutskirtBuildings.Library] = IdModal.Library,
    _a[IdOutskirtBuildings.Nursery] = IdModal.Nursery,
    _a[IdOutskirtBuildings.ExternalBarn] = "not-implemented",
    _a[IdOutskirtBuildings.Pier] = IdModal.Pier,
    _a[IdOutskirtBuildings.Watertower] = IdModal.WaterTower,
    _a[IdOutskirtBuildings.TournamentTent] = IdModal.TournamentTent,
    _a[IdOutskirtBuildings.ThemedEvent] = IdModal.ThemedEvent,
    _a);
export var epicShowMeUseOutskirt = function (action$) {
    return action$.pipe(ofType(TypeActionShowMe.QuestTaskUseOutskirt), map(function (action) {
        var task = action.taskType;
        if (task.outsideBuildingId === IdOutskirtBuildings.ExternalBarn) {
            return actionOutskirtBuildingSelect(IdOutskirtBuildings.ExternalBarn);
        }
        return actionModalSwapLast(menuIdsByOutskirtBuildingIds[task.outsideBuildingId]);
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/quest-tasks/use-outskirt/epicShowMeUseOutskirt.ts
// module id = 2398
// module chunks = 3